import { createFileRoute } from '@tanstack/react-router';
import { AdminOrgEntitlementsPage } from '../../features/billing';

export const Route = createFileRoute('/admin/usage/$orgId')({
  component: function OrgEntitlementsRoute() {
    const { orgId } = Route.useParams();
    return <AdminOrgEntitlementsPage orgId={orgId} />;
  },
});
